export const SELLER = {
  name: 'Anadolu Makina A.Ş.',
  address: 'ASO 1. OSB, Ceyhun Atuf Kansu Cd. No: 14',
  city: '06935 Sincan / Ankara',
  taxOffice: 'Ostim', vkn: '0680412357',
  phone: '+90 312 267 40 00', email: 'satis@anadolumakina.com.tr'
};

export const CUSTOMERS = [
  { id: 'C1001', name: 'ABC Endüstri A.Ş.', alias: ['abc'], address: 'İvedik OSB, 1354. Cd. No: 88', city: '06378 Yenimahalle / Ankara', taxOffice: 'İvedik', vkn: '0010293847', contact: 'Murat Yılmaz', email: 'murat.yilmaz@abcendustri.com', payTerm: 30, discount: 5, creditLimit: 750000, openBalance: 182400, pastQuotes: 7, lastWin: 'Mart 2026' },
  { id: 'C1002', name: 'Beta Metal San. ve Tic. Ltd. Şti.', alias: ['beta'], address: 'Başkent OSB, 22. Cd. No: 7', city: '06909 Sincan / Ankara', taxOffice: 'Sincan', vkn: '1650938271', contact: 'Elif Demirtaş', email: 'elif@betametal.com.tr', payTerm: 45, discount: 3, creditLimit: 400000, openBalance: 96500, pastQuotes: 4, lastWin: 'Ocak 2026' },
  { id: 'C1003', name: 'Çelik Vana Ltd. Şti.', alias: ['çelik vana', 'celik vana', 'çelik', 'celik'], address: 'Ostim OSB, 1203. Sk. No: 15', city: '06374 Yenimahalle / Ankara', taxOffice: 'Ostim', vkn: '2230917465', contact: 'Hakan Öztürk', email: 'hakan@celikvana.com.tr', payTerm: 30, discount: 0, creditLimit: 250000, openBalance: 211300, pastQuotes: 12, lastWin: 'Nisan 2026' },
  { id: 'C1004', name: 'Doğa Pompa Sistemleri A.Ş.', alias: ['doğa', 'doga'], address: 'Konya OSB, Büyükkayacık Mh. 4. Sk. No: 3', city: '42300 Selçuklu / Konya', taxOffice: 'Selçuklu', vkn: '3091827364', contact: 'Zeynep Kara', email: 'zeynep.kara@dogapompa.com.tr', payTerm: 60, discount: 7, creditLimit: 1200000, openBalance: 305000, pastQuotes: 19, lastWin: 'Mayıs 2026' },
  { id: 'C1005', name: 'Kuzey Hidrolik Makina San. A.Ş.', alias: ['kuzey'], address: 'Saray OSB, 3. Cd. No: 41', city: '06980 Kahramankazan / Ankara', taxOffice: 'Kahramankazan', vkn: '5820193746', contact: 'Burak Şen', email: 'burak.sen@kuzeyhidrolik.com', payTerm: 30, discount: 4, creditLimit: 500000, openBalance: 48750, pastQuotes: 3, lastWin: 'Şubat 2026' }
];

export const PRODUCTS = [
  { code: 'FLN-DN50-PN16', name: 'Kaynak boyunlu flanş DN50', alias: ['dn50'], spec: 'PN16 · EN 1092-1 · P250GH', unit: 'adet', price: 1250, stock: 50, depot: 'Sincan Ana Depo', lead: 3 },
  { code: 'FLN-DN80-PN16', name: 'Kaynak boyunlu flanş DN80', alias: ['dn80'], spec: 'PN16 · EN 1092-1 · P250GH', unit: 'adet', price: 1875, stock: 35, depot: 'Sincan Ana Depo', lead: 3 },
  { code: 'FLN-DN100-PN16', name: 'Kaynak boyunlu flanş DN100', alias: ['dn100'], spec: 'PN16 · EN 1092-1 · P250GH', unit: 'adet', price: 2450, stock: 20, depot: 'Sincan Ana Depo', lead: 5 },
  { code: 'FLN-DN150-PN16', name: 'Kaynak boyunlu flanş DN150', alias: ['dn150'], spec: 'PN16 · EN 1092-1 · P250GH', unit: 'adet', price: 3980, stock: 8, depot: 'Ostim Depo', lead: 7 },
  { code: 'VLV-KUR-1', name: 'Küresel vana 1"', alias: ['küresel vana', 'kuresel vana', 'vana'], spec: 'Paslanmaz 316 · PN40 · diş bağlantılı', unit: 'adet', price: 640, stock: 80, depot: 'Sincan Ana Depo', lead: 2 },
  { code: 'VLV-KEL-DN50', name: 'Kelebek vana DN50', alias: ['kelebek'], spec: 'Döküm gövde · EPDM conta · wafer', unit: 'adet', price: 1120, stock: 40, depot: 'Ostim Depo', lead: 4 },
  { code: 'RLM-6205-2RS', name: 'Rulman 6205-2RS', alias: ['rulman', '6205'], spec: 'Sabit bilyalı · 25×52×15 mm', unit: 'adet', price: 210, stock: 120, depot: 'Sincan Ana Depo', lead: 2 },
  { code: 'CVT-M12-88', name: 'Altıgen cıvata M12×50', alias: ['cıvata', 'civata', 'm12'], spec: '8.8 kalite · galvaniz · DIN 933', unit: 'adet', price: 18, stock: 500, depot: 'Sincan Ana Depo', lead: 1 },
  { code: 'CNT-DN50-KLG', name: 'Klingerit conta DN50', alias: ['conta'], spec: 'PN16 · 2 mm · asbestsiz', unit: 'adet', price: 85, stock: 300, depot: 'Ostim Depo', lead: 2 },
  { code: 'DRS-DN50-90', name: 'Dirsek 90° DN50', alias: ['dirsek'], spec: 'Dikişsiz · P235GH · 3D', unit: 'adet', price: 310, stock: 150, depot: 'Sincan Ana Depo', lead: 3 },
  { code: 'MLN-DN50-3M', name: 'Dikişsiz boru DN50', alias: ['boru'], spec: 'ST37 · 3,91 mm et · 6 m boy', unit: 'metre', price: 540, stock: 240, depot: 'Ostim Depo', lead: 4 }
];

const lower = t => t.toLocaleLowerCase('tr-TR');

export function parseCommand(text) {
  const t = ' ' + lower(text).replace(/[’'`]/g, ' ') + ' ';
  const customer = CUSTOMERS.find(c => c.alias.some(a => t.includes(a)));
  // find product mentions with positions
  const hits = [];
  PRODUCTS.forEach(p => {
    for (const a of p.alias) {
      const idx = t.indexOf(a);
      if (idx >= 0) {
        // avoid 'vana' matching inside 'çelik vana' customer alias or 'kelebek vana'
        if (a === 'vana' && (/çelik vana|celik vana|kelebek vana|küresel vana|kuresel vana/.test(t.slice(Math.max(0, idx - 8), idx + 4)))) continue;
        if (customer && customer.alias.some(ca => { const ci = t.indexOf(ca); return ci >= 0 && idx >= ci && idx < ci + ca.length; })) continue;
        hits.push({ p, idx, len: a.length });
        break;
      }
    }
  });
  hits.sort((a, b) => a.idx - b.idx);
  // de-dup overlapping
  const items = [];
  let lastEnd = -1;
  hits.forEach(h => { if (h.idx >= lastEnd) { items.push(h); lastEnd = h.idx + h.len; } });
  // qty: closest number before product mention (after previous product), else after
  const nums = [];
  const re = /(\d{1,3}(?:[.\s]\d{3})+|\d+)\s*(adet|tane|metre|mt|m\b|ad\b)?/g;
  let m;
  while ((m = re.exec(t))) {
    const raw = m[1];
    const val = parseInt(raw.replace(/[.\s]/g, ''), 10);
    // skip numbers that are part of product codes like dn50, m12, 6205
    const prev = t.slice(Math.max(0, m.index - 2), m.index);
    if (/dn$|m$|n$/.test(prev)) continue;
    if (raw === '6205') continue;
    nums.push({ val, idx: m.index, used: false, unitHint: !!m[2] });
  }
  const lines = items.map((h, i) => {
    const prevEnd = i > 0 ? items[i - 1].idx + items[i - 1].len : 0;
    let cand = nums.filter(n => !n.used && n.idx >= prevEnd && n.idx < h.idx).pop();
    if (!cand) cand = nums.find(n => !n.used && n.idx > h.idx);
    if (cand) cand.used = true;
    return { product: h.p, qty: cand ? cand.val : null };
  });
  return { customer, lines };
}

function numToWordsTR(n) {
  const ones = ['', 'bir', 'iki', 'üç', 'dört', 'beş', 'altı', 'yedi', 'sekiz', 'dokuz'];
  const tens = ['', 'on', 'yirmi', 'otuz', 'kırk', 'elli', 'altmış', 'yetmiş', 'seksen', 'doksan'];
  const scales = ['', 'bin', 'milyon', 'milyar'];
  function three(x) {
    const h = Math.floor(x / 100), t = Math.floor((x % 100) / 10), o = x % 10;
    let s = '';
    if (h) s += (h > 1 ? ones[h] : '') + 'yüz';
    s += tens[t] + ones[o];
    return s;
  }
  if (n === 0) return 'sıfır';
  let out = '', i = 0;
  while (n > 0) {
    const chunk = n % 1000;
    if (chunk) {
      let w = (i === 1 && chunk === 1) ? '' : three(chunk);
      out = w + scales[i] + out;
    }
    n = Math.floor(n / 1000); i++;
  }
  return out;
}

export function amountWords(total) {
  const tl = Math.floor(total);
  const kr = Math.round((total - tl) * 100);
  let s = numToWordsTR(tl) + ' Türk lirası';
  if (kr) s += ' ' + numToWordsTR(kr) + ' kuruş';
  return s.charAt(0).toLocaleUpperCase('tr-TR') + s.slice(1);
}

export function computeQuote(parsed) {
  const c = parsed.customer;
  const notes = [];
  const items = parsed.lines.map(l => {
    const p = l.product, qty = l.qty;
    let disc = c.discount;
    const volume = qty >= 100 ? 3 : 0;
    disc += volume;
    const gross = p.price * qty;
    const net = +(gross * (1 - disc / 100)).toFixed(2);
    let leadDays = p.lead, leadText = p.lead + ' iş günü', stockOk = true;
    if (qty > p.stock) {
      stockOk = false;
      leadDays = p.lead + 10;
      leadText = p.stock + ' ' + p.unit + ' ' + p.lead + ' gün, kalanı ' + leadDays + ' iş günü';
      notes.push(p.name + ': stokta ' + p.stock + ' ' + p.unit + ' mevcut. Kalan ' + (qty - p.stock) + ' ' + p.unit + ' üretim planına alınarak ' + leadDays + ' iş günü içinde sevk edilecektir.');
    }
    if (volume) notes.push(p.name + ' için 100 ' + p.unit + ' üzeri alımda %3 hacim iskontosu uygulanmıştır.');
    return { code: p.code, name: p.name, spec: p.spec, unit: p.unit, qty, price: p.price, disc, gross, net, leadDays, leadText, stockOk, stock: p.stock, depot: p.depot };
  });
  const gross = items.reduce((a, b) => a + b.gross, 0);
  const net = +items.reduce((a, b) => a + b.net, 0).toFixed(2);
  const discount = +(gross - net).toFixed(2);
  const vat = +(net * 0.2).toFixed(2);
  const total = +(net + vat).toFixed(2);
  const maxLead = Math.max(...items.map(i => i.leadDays));
  const creditAfter = c.openBalance + total;
  const creditOk = creditAfter <= c.creditLimit;
  if (!creditOk) notes.push('Müşteri açık bakiyesi ile birlikte kredi limiti aşılmaktadır. Sevkiyat öncesi %30 ön ödeme talep edilir.');
  return {
    items, gross, net, discount, vat, total, maxLead, creditOk, creditAfter, notes,
    totalWords: amountWords(total),
    terms: {
      payment: creditOk ? c.payTerm + ' gün vadeli, havale / EFT' : '%30 peşin, bakiye ' + c.payTerm + ' gün vadeli',
      lead: 'Sipariş onayından itibaren ' + maxLead + ' iş günü',
      delivery: 'Fabrika teslim (EXW Sincan / Ankara)',
      validity: '15 gün'
    }
  };
}

